export default {
  methods: {
    generateWazeURL(locationCoords, userCoords){
      return 'https://www.waze.com/livemap/directions?navigate=yes&to=ll.'+locationCoords[1]+'%2C'+locationCoords[0]+'&from=ll.'+userCoords[1]+'%2C'+userCoords[0]
    },
    generateGoogleURL(locationCoords, userCoords){
      return 'https://www.google.com/maps/dir/?api=1&origin='+userCoords[1]+','+userCoords[0]+'&destination='+locationCoords[1]+','+locationCoords[0]
    },
  }
}